import React from "react";
import homepage from "../assets/homepage.mp4";

const HeroSection = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&family=Poppins:wght@300;400;500;600;700&display=swap');

        .digital-experiences-text {
          font-family: 'Space Grotesk', sans-serif;
          font-weight: 700;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          background: linear-gradient(135deg, #129ADC, #B55DD0, #E154AA, #F45A39);
          background-size: 200% 200%;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          animation: shimmer 4s linear infinite;
          line-height: 1.15;
          word-break: break-word;
        }

        @keyframes shimmer {
          0%   { background-position: 0% 50%; }
          50%  { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        .glass-tag {
          position: relative;
          font-family: 'Poppins', sans-serif;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.88);
          border-radius: 100px;
          cursor: default;
          background: rgba(255, 255, 255, 0.06);
          backdrop-filter: blur(16px) saturate(180%);
          -webkit-backdrop-filter: blur(16px) saturate(180%);
          border: 1px solid rgba(255, 255, 255, 0.14);
          box-shadow:
            inset 0 1px 0 rgba(255, 255, 255, 0.12),
            0 4px 20px rgba(0, 0, 0, 0.3),
            0 1px 8px rgba(18, 154, 220, 0.08);
          transition: transform 0.22s ease, box-shadow 0.22s ease, background 0.22s ease;
          overflow: hidden;
          white-space: nowrap;
        }

        .glass-tag::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 1px;
          background: linear-gradient(90deg, transparent, rgba(181,93,208,0.5), rgba(18,154,220,0.5), transparent);
          border-radius: 100px 100px 0 0;
        }

        .glass-tag:hover {
          transform: translateY(-3px);
          background: rgba(255, 255, 255, 0.11);
          box-shadow:
            inset 0 1px 0 rgba(255, 255, 255, 0.18),
            0 8px 28px rgba(0, 0, 0, 0.35),
            0 2px 14px rgba(181, 93, 208, 0.18);
        }

        /* Mobile: smaller tags, allow wrap */
        @media (max-width: 640px) {
          .tags-wrapper {
            gap: 10px !important;
          }
          .glass-tag {
            font-size: 0.68rem;
            padding: 7px 14px;
            white-space: normal;
            text-align: center;
          }
          .hero-inner {
            padding-top: 120px !important;
          }
          .designing-label {
            font-size: 0.65rem !important;
            letter-spacing: 0.28em !important;
          }
          .with-syntax-label {
            font-size: 0.65rem !important;
            letter-spacing: 0.22em !important;
          }
        }

        /* Tablet */
        @media (min-width: 641px) and (max-width: 1023px) {
          .glass-tag {
            font-size: 0.72rem;
            padding: 8px 18px;
          }
          .hero-inner {
            padding-top: 160px !important;
          }
        }

        /* Desktop */
        @media (min-width: 1024px) {
          .glass-tag {
            font-size: 0.78rem;
            padding: 9px 22px;
          }
        }
      `}</style>

      <section
        id="home"
        className="relative min-h-screens flex flex-col items-center justify-center text-center px-4 pt-2 pb-28"
      >
        {/* Background Video */}
        <video
          autoPlay
          loop
          muted
          playsInline
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: 0,
          }}
        >
          <source src={homepage} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Content */}
        <div
          className="hero-inner flex flex-col min-h-screen items-center justify-center text-center px-4 pb-16 z-10 w-full"
          // style={{ paddingTop: "14rem" }}
        >
          {/* DESIGNING label */}
          <p
            className="designing-label text-sm sm:text-base font-medium uppercase mb-3"
            style={{
              fontFamily: "'Poppins', sans-serif",
              letterSpacing: "0.42em",
              color: "#ffffff",
            }}
          >
            WE BUILD
          </p>

          {/* DIGITAL EXPERIENCES — gradient text */}
          <h1
            className="digital-experiences-text text-3xl sm:text-5xl md:text-6xl lg:text-5xl mb-2 px-2"
            style={{
              letterSpacing: "0.01em",
            }}
          >
            BRANDS THAT STAND OUT
          </h1>

          {/* with Perfect Syntax */}
          <p
            className="with-syntax-label uppercase mt-1 mb-8"
            style={{
              fontFamily: "'Poppins', sans-serif",
              fontSize: "0.78rem",
              letterSpacing: "0.32em",
              color: "#ffffff",
            }}
          >
            WITH STRATEGY, DESIGN & CREATIVITY
          </p>

          {/* Tags */}
          <div
            className="tags-wrapper mt-auto flex flex-wrap justify-center pb-6 absolute bottom-40"
            style={{ gap: "2.5rem" }}
          >
            {["Branding", "Social Media", "Web Design", "Packaging"].map((tag) => (
              <span
                key={tag}
                className="glass-tag"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;